import React from 'react';

import AboutView from "views/user/about/AboutView.jsx";

import { Button } from "@progress/kendo-react-buttons";

import WindowDialog from "views/widgets/WindowDialog.jsx";

export default function AboutDialog(props) {
		
	const { okCallback } = props;
	
	const render = () => {
		return (
			<AboutView okCallback={okCallback} />
		);
	};
	
	const getDialogButtons = () => {
		const buttons = [];
		buttons.push(
           	<Button
           		tabIndex={0}
           		key="cancel"
           		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
           		onClick={okCallback}
           	>
            	Close
           	</Button>			
		);
		return buttons;
	};

	return (
		<WindowDialog 
			title="About Constituo Content"
			className={"constituo-about-dialog constituo-window-dialog"}
			onClose={okCallback}
			initialHeight={500}
			minHeight={300}
			initialWidth={550}
			minWidth={400}
			render={render}
			buttons={getDialogButtons()}
		/>
	);
}
